<template>
  <div class="container login">
    <h2>{{title}} with</h2>
    <div class="social-login">
      <!-- <button class="btn btn-fill btn-facebook btn-social" type="button" @click="onProviderClick('facebook')">
        <FacebookIcon w="32px" h="32px" />Facebook
      </button> -->
      <button class="btn btn-fill btn-google btn-social" type="button" @click="onProviderClick('google')">
        <span class="icon-google"></span>
        <span class="text-google">Google</span>
      </button>
    </div>
    <h2>Or</h2>
    <form class="" action="#">
      <slot>
      </slot>
      <div class="form-group">
        <input
          id="email"
          type="email"
          class="form-control"
          v-bind:class="[$v.email]"
          placeholder="Email address"
          v-model="credentials.email"
          v-on:blur="onBlur($event)"
          required
          autofocus
        />
        <div class="invalid-feedback">A valid email is required</div>
      </div>
      <div class="form-group">
        <input
          id="password"
          type="password"
          class="form-control"
          v-bind:class="[$v.password]"
          placeholder="Password"
          v-model="credentials.password"
          v-on:blur="onBlur($event)"
          required
        />
        <div class="invalid-feedback">A password is required</div>
      </div>
      <router-link v-if="!noForgot" to="forgot" id="forgot_pass" class="float-right">Forgot password?</router-link>
      <button class="btn btn-fill" type="button" @click="onLoginClick">
        {{title}}
      </button>
      <slot name="footer" v-if="!noFooter">
        <div class="login-footer">
          <span>Don't have an account yet? </span><router-link to="signup">Sign up now</router-link>
        </div>
        <!-- <pre>{{credentials}}</pre> -->
      </slot>
    </form>
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api"
import FacebookIcon from "vue-ionicons/dist/logo-facebook";
import GoogleIcon from "vue-ionicons/dist/logo-google";
import { useValidator } from "src/components/validator.js"

export default {
  components: {
    FacebookIcon,
    GoogleIcon
  },
  props: {
    title: {
      type: String,
      default: 'Sign in'
    },
    signUpRef: {
      type: String,
      default: '#/signup'
    },
    forgotRef: {
      type: String,
      default: '#/forgot'
    },
    noForgot: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const credentials = reactive({
      email: null,
      password: null,
      mode: ''
    });
    const $v = useValidator({
      email: {
        presence: true,
        email: true,
      },
      password: {
        presence: { allowEmpty: false }
      }
    })
    function onLoginClick() {
      const isValid = $v.validateAll({
        email: credentials.email,
        password: credentials.password
      })
      context.emit('login', {
        isValid: isValid,
        credentials: credentials
      })
    }
    function onProviderClick(provider) {
      context.emit('provider', provider)
    }
    function onBlur(e) {
      $v.validateEvent(e)
    }
    return {
      credentials,
      onLoginClick,
      onProviderClick,
      '$v': $v.model,
      onBlur
    }
  }
}
</script>
<style lang="scss">
.login {
  // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  // opacity: 0.8;
  background-color: rgba($color: #fff, $alpha: 0.90);
  // border: 1px solid red;
  max-width: 768px;
  padding: 32px 32px 32px 32px;
  @media (min-width: 768px) {
    border-radius: 10px;
    padding: 32px 110px 32px 110px;
  }
  color: #555;

  h2 {
    font-size: 28px;
    margin: 24px 0 24px;
    text-align: center;
  }

  .social-login {
    justify-content: center;
    align-items: center;
    width: 100%;
    display: flex;
  }

  .btn {
    line-height: 1.2;
    font-size: 120%;
  }

  .btn-social {
    display: flex;
    align-items: center;
    // justify-content: default;
    border-radius: 10px;
    padding: 15px;
    height: 70px;
    // width: calc((100% - 42px) / 2);
    // width: calc((100% - 42px) / 2);

    img,
    div.ion {
      margin-right: 4px;
    }
  }

  .btn-facebook {
    background-color: #3b5998;
  }

  .btn-google {
    background-color: #ffffff;
    color: #444;

    .icon-google {
      background: url('/me/img/icons/icon-google.png') transparent 5px 50% no-repeat;
      display: inline-block;
      vertical-align: middle;
      width: 42px;
      height: 42px;
    }
    .text-google {
      display: inline-block;
      vertical-align: middle;
      padding-left: 24px;
      padding-right: 24px;
      font-size: 14px;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
      text-transform: uppercase;
    }

  }

  .form-control {
    height: 60px;
    font-size: 120%;
  }

  .login-footer {
    padding-top: 24px;
    text-align: center;
    color: #555;

    a {
      border-bottom: 1px solid;
    }

  }

}
</style>